<template>
  <div class="my-flights-box">
    <b class="back-btn" @click="back">
      <i class="fas fa-chevron-left"></i>
      Back to Booking form
    </b>

    <div class="d-flex tabs-status">
      <div :class="['-tab', {active:tab.active === 'upcoming'}]" @click="changeTab('upcoming')">UPCOMING</div>
      <div :class="['-tab', {active:tab.active === 'complete'}]" @click="changeTab('complete')">COMPLETED</div>
      <div :class="['-tab', {active:tab.active === 'canceled'}]" @click="changeTab('canceled')">CANCELED</div>
      <select v-model="tab.active" @change="changeTab(tab.active)">
        <option value="upcoming">UPCOMING</option>
        <option value="complete">COMPLETED</option>
        <option value="canceled">CANCELED</option>
      </select>
    </div>

    <div class="tabcontent">
      <!-- <div class="f-breadcrumb d-flex title-container" v-if="!track.enable">
        <div @click="showList">FLIGHTS</div>
        <i class="fas fa-chevron-right" v-if="bcrumb >= 2"></i>
        <div v-if="bcrumb >= 2">DETAILS</div>
      </div> -->
  
      <transition name="page" mode="out-in">
        <div class="flight-list padding-t-s" v-if="!showSelected">
          <div :class="['flight-box2', {'ground-mode':f.isGround}]" v-for="(f, i) in flights.list" :key="i" @click="getRaw(f)">
            <div class="d-flex">
              <div class="fl-logo">
                <img :src="f.logo" :alt="f.logo" />
              </div>
              <div class="fl-info">
                <div class="fl-date d-flex justify-space-between" v-if="!f.isGround">
                  <span :class="['refund-label', {non:!f.isRefundable}]">{{f.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'}}</span>
                  <span>{{dateOnly(f.origin.date)}}</span>
                </div>
                <div class="fl-date d-flex justify-end" v-else>
                  <span>{{f.pickupDate}}</span>
                </div>
                <div class="d-flex align-stretch">
                  <div class="fl-code" v-if="!f.isGround">{{f.origin.code}}</div>
                  <div class="fl-code" v-else>{{f.pickup}}</div>
                  <div class="fl-pnr">
                    <i class="fas fa-plane fa-fw fa-2x" v-if="!f.isGround"></i>
                    <i class="fas fa-car-side fa-fw fa-2x" v-else></i>
                    <div class="pnr-info" v-if="!f.isGround">
                      <label>PNR</label>
                      <span>{{f.pnr || '--'}}</span>
                    </div>
                    <div class="pnr-info" v-else>
                      <span>{{f.service.name}}</span>
                    </div>
                  </div>
                  <div class="fl-code" v-if="!f.isGround">{{f.destination.code}}</div>
                  <div class="fl-code" v-else>{{f.dropoff}}</div>
                  <div class="fl-spacer">
                    <i class="fas fa-chevron-right fa-fw fa-2x"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex fl-rt" v-if="!!f.roundTripData">
              <div class="fl-logo">
                <img :src="f.roundTripData.logo" :alt="f.roundTripData.logo" />
              </div>
              <div class="fl-info">
                <div class="fl-date d-flex justify-space-between">
                  <span></span>
                  <span>{{dateOnly(f.roundTripData.origin.date)}}</span>
                </div>
                <div class="d-flex align-stretch">
                  <div class="fl-code">{{f.roundTripData.origin.code}}</div>
                  <div class="fl-pnr">
                    <i class="fas fa-plane fa-fw fa-2x"></i>
                    <div class="pnr-info">
                      <label>PNR</label>
                      <span>{{f.roundTripData.pnr || '--'}}</span>
                    </div>
                  </div>
                  <div class="fl-code">{{f.roundTripData.destination.code}}</div>
                  <div class="fl-spacer">
                    <i class="fas fa-chevron-right fa-fw fa-2x"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
      </transition>

      <transition name="page" mode="out-in">
        <div class="flight-list-empty" v-if="!flights.list.length">
          No flight records.
        </div>
      </transition>
    </div>

    <transition name="page" mode="out-in">
      <details-page v-if="showSelected" />
    </transition>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import detailsPage from './details'
import airlines from '@/data/airlines.js'
import ft from '@/modules/api/featureToggle'
import ApiRsvpSearch from '@/modules/api/reservation-search'

export default {
  name: 'flight-list',
  components: { detailsPage },
  data () {
    return {
      isMobile: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
      rtLoaded: false,
      showSelected: false,
      tab: {
        active: 'upcoming',
        loading: false
      },
      bcrumb: 1
    }
  },
  computed: {
    brandId () { return this.$store.state.brandId },
    user () { return this.$store.state.user },
    rsvp () { return this.$store.state.reservation },
    flights () { return this.$store.state.flights },
    track () { return this.flights.track },
    lyftStore () { return this.$store.state.lyft }
  },
  methods: {
    back () {
      this.$router.push('search')
    },
    showList () {
      this.showSelected = false
      this.bcrumb = 1
    },
    getRaw (x) {
      let self = this
      if (x.isAsap) {
        self.getRsvpASAP(x)
        return
      }
      if (x.isGround) {
        self.rerouteToGround(x.id)
        return
      }
      self.$store.commit('global/setLoaderData', {show: true})
      self.rtLoaded = false
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/get`, {
        token: self.user.token,
        order: 'createTime',
        desc: true,
        pageNum: 1,
        pageSize: 2,
        raw: true,
        id: x.id
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let data = r.list[0]
        let tmp = {
          id: data.id,
          bookingId: data.bookingId,
          booked: moment(data.createdUTC, 'X').format('MM/DD/YYYY hh:mmA'),
          pnr: data.pnr,
          airFareTotal: data.fareFlightTotal,
          roundtripId: data.roundTripId,
          credits: data.credits || 0,
          flights: {
            oneway: [],
            return: []
          },
          pax: [],
          status: data.status,
          isRefundable: data.isRefundable
        }
        let flightDetails = data.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.FlightDetails.Details
        flightDetails[0].forEach(f => {
          tmp.flights.oneway.push({
            flightName: f.OperatorName,
            flightCode: f.OperatorCode,
            flightNo: f.FlightNumber,
            duration: f.Duration,
            origin: {
              code: f.Origin.AirportCode,
              name: f.Origin.AirportName,
              date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
            },
            destination: {
              code: f.Destination.AirportCode,
              name: f.Destination.AirportName,
              date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
            }
          })
        })
        if (data.roundTripId && flightDetails[1]) {
          flightDetails[1].forEach(f => {
            tmp.flights.return.push({
              flightName: f.OperatorName,
              flightCode: f.OperatorCode,
              flightNo: f.FlightNumber,
              duration: f.Duration,
              origin: {
                code: f.Origin.AirportCode,
                name: f.Origin.AirportName,
                date: moment(f.Origin.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
              },
              destination: {
                code: f.Destination.AirportCode,
                name: f.Destination.AirportName,
                date: moment(f.Destination.DateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
              }
            })
          })
        }
        data.commitData.CommitBooking.BookingDetails.PassengerDetails.forEach(p => {
          tmp.pax.push({
            firstName: p.FirstName,
            lastName: p.LastName,
            ticketId: p.TicketId,
            ticketNo: p.TicketNumber
          })
        })
        let flightData = {
          selected: tmp,
          availableGround: [],
          currency: {code: 'USD'}
        }
        if (data.currency) {
          flightData.currency = {
            code: data.currency.currency,
            flight: data.currency.flight,
            credits: data.currency.credits
          }
        }
        self.$store.commit('flights/setFlightData', flightData)
        let rsvps = []
        let isLeg1 = true
        let availableGround = []
        if (data.roundTripId) isLeg1 = data.id < data.roundTripId
        if (data.rsvpId1) {
          availableGround.push(isLeg1 ? 1 : 3)
          rsvps.push({id: data.rsvpId1, target: isLeg1 ? 'rsvp1' : 'rsvp3'})
        }
        if (data.rsvpId2) {
          availableGround.push(isLeg1 ? 2 : 4)
          rsvps.push({id: data.rsvpId2, target: isLeg1 ? 'rsvp2' : 'rsvp4'})
        }
        self.$store.commit('flights/setFlightData', {availableGround: availableGround})
        if (rsvps.length) self.getRsvpData(rsvps)
        else {
          self.$store.commit('global/setLoaderData', {show: false})
          self.showSelected = true
          self.bcrumb = 2
        }
      })
    },
    getRsvpData (rsvps) {
      let self = this
      if (!rsvps.length) {
        if (!self.rtLoaded && this.flights.selected.roundtripId) {
          self.rtLoaded = true
          self.getRoundtripRsvp(this.flights.selected.roundtripId)
          return
        }
        self.$store.commit('global/setLoaderData', {show: false})
        self.showSelected = true
        self.bcrumb = 2
        return
      }
      let firstName = self.user.firstName
      // firstName = firstName.split(' ')[firstName.split(' ').length - 1]
      let lastName = self.user.lastName
      // lastName = lastName.split(' ')[lastName.split(' ').length - 1]
      self.$sdk.get(self, `/reservations/${rsvps[0].id}/${firstName}/${lastName}`, {}, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let tmp = {}
        let total = parseFloat(r.breakdown.total || 0) + (r.gasFee || 0)
        let pickupDate = moment(r.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(r.pickupTimezone)
        let dateFormat = 'MM/DD/YYYY hh:mmA'
        let status = 'Driver is not Assigned'
        if (r.provider.ID) {
          status = 'Driver is not Assigned'
          if (r.status === 'ontheway') status = 'Driver is on the way To Pickup.'
          if (r.onboard) status = 'Driver is on the way To Dropoff.'
        }
        if (r.canceled) status = 'Trip Canceled.'
        if (r.complete) status = 'Trip Completed.'
        tmp[rsvps[0].target] = {
          id: r.ID,
          service: r.serviceType.label,
          img: r.serviceType.image,
          pickup: r.pickupLocation,
          dropoff: r.dropoffLocation,
          pickupDate: pickupDate.format(dateFormat),
          eta: pickupDate.add(r.etaInSec, 'seconds').format(dateFormat),
          payment: total.toFixed(2),
          status: status
        }
        self.getCurrencyData(tmp, rsvps)
        // self.$store.commit('flights/setFlightData', tmp)
        // rsvps.shift()
        // self.getRsvpData(rsvps)
      })
    },
    getCurrencyData (tmp, rsvps) {
      let self = this
      let firstName = self.user.firstName
      let lastName = self.user.lastName
      self.$sdk.get(self, `/reservations/${rsvps[0].id}/${firstName}/${lastName}/currency`, {}, r => {
        if (!r.error) {
          let total = r.airportFee + r.amount + r.gasFee + r.pickupFee + r.tipAmount + r.travelInsurance
          total -= r.credit
          r.total = parseFloat(total.toFixed(2))
          tmp[rsvps[0].target].currency = r
        }

        self.$store.commit('flights/setFlightData', tmp)
        rsvps.shift()
        self.getRsvpData(rsvps)
      })
    },
    getRoundtripRsvp (id) {
      let self = this
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/get`, {
        token: self.user.token,
        order: 'createTime',
        desc: true,
        pageNum: 1,
        pageSize: 2,
        raw: true,
        id: id
      }, r => {
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        let data = r.list[0]
        let rsvps = []
        let isLeg1 = true
        let availableGround = []
        if (data.roundTripId) {
          isLeg1 = data.id < data.roundTripId
        }
        if (data.rsvpId1) {
          availableGround.push(isLeg1 ? 1 : 3)
          rsvps.push({id: data.rsvpId1, target: isLeg1 ? 'rsvp1' : 'rsvp3'})
        }
        if (data.rsvpId2) {
          availableGround.push(isLeg1 ? 2 : 4)
          rsvps.push({id: data.rsvpId2, target: isLeg1 ? 'rsvp2' : 'rsvp4'})
        }
        self.$store.commit('flights/addAvailableGround', availableGround)
        if (rsvps.length) self.getRsvpData(rsvps)
      })
    },
    changeTab (x) {
      if (this.tab.loading) return
      this.tab.active = x
      if (this.lyftStore.services.length) {
        this.getFlights()
        return
      }
      this.getLyftServices()
    },
    getLyftServices () {
      let self = this
      self.$sdk.get(self, '/service/lyft', {}, res => {
        if (!res.error) self.$store.commit('lyft/setLyftData', {services: res})
        self.getFlights()
      }, '2.0')
    },
    getFlights () {
      let self = this
      // self.showLoggedInOptions = false
      self.$store.commit('global/setLoaderData', {show: true})
      self.tab.loading = true
      self.$sdk.post2(`${CONFIG.d2dGateway}/d2d/get`, {
        token: self.user.token,
        order: 'createTime',
        status: self.tab.active,
        desc: false,
        pageNum: 1,
        pageSize: 40,
        raw: true
      }, r => {
        self.tab.loading = false
        if (r.error) {
          // self.$store.commit('global/setLoaderData', {show: false})
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: r.error.message
          // })
          self.getGroundBookings()
          return
        }
        if (!r.list.length) {
          // self.$store.commit('global/setLoaderData', {show: false})
          // self.$store.commit('global/setAlertData', {
          //   show: true,
          //   message: 'No booked flights as of yet.'
          // })
          self.$store.commit('flights/setFlightData', {list: []})
          // self.$store.commit('flights/setFlightTrackData', {enable: false})
          // self.showSelected = false
          // self.bcrumb = 1
          self.getGroundBookings()
          return
        }
        let flights = []
        r.list.forEach(f => {
          if (f.roundTripId) {
            let index = flights.findIndex(x => x.id === f.roundTripId)
            if (index > -1) {
              flights[index].roundTripData = self.buildFlightListData(f)
              return
            }
          }
          flights.push(self.buildFlightListData(f))
        })
        flights.sort((a, b) => {
          return a.dateSort - b.dateSort
        })
        self.$store.commit('flights/setFlightData', {list: flights})
        self.getGroundBookings()
        // setTimeout(function () {
        //   self.$store.commit('global/setLoaderData', {show: false})
        //   self.$store.commit('flights/setFlightTrackData', {enable: false})
        //   self.showSelected = false
        //   self.bcrumb = 1
        // }, 250)
      })
    },
    buildFlightListData (f) {
      let logo = ''
      if (f.commitData && f.commitData.CommitBooking && f.commitData.CommitBooking.BookingDetails.JourneyList.FlightDetails.Details.length) {
        logo = f.commitData.CommitBooking.BookingDetails.JourneyList.FlightDetails.Details[0][0].DisplayOperatorCode
        let tmp = airlines.find(x => x.code === logo)
        if (tmp) logo = tmp.logo
      }
      let isRefundable = false
      if (f.priceData) isRefundable = f.priceData.UpdateFareQuote.FareQuoteDetails.JourneyList.Attr.IsRefundable
      return {
        id: f.id,
        bookingId: f.bookingId,
        pnr: f.pnr,
        origin: {
          code: f.originAirportCode,
          name: f.originAirportName,
          date: moment(f.originDateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        },
        destination: {
          code: f.destAirportCode,
          name: f.destAirportName,
          date: moment(f.destDateTime, 'YYYY-MM-DD HH:mm').format('MM/DD/YYYY hh:mmA')
        },
        status: f.status,
        // isRoundTrip: f.roundTripId ? (f.id < f.roundTripId ? 'round-trip' : '') : '',
        dateSort: parseInt(moment(f.originDateTime, 'YYYY-MM-DD HH:mm').format('x')),
        logo: logo,
        isRefundable: isRefundable
      }
    },
    getGroundBookings () {
      let self = this
      let url = '/me/reservations/upcoming'
      if (self.tab.active === 'complete') url = '/me/reservations/past'
      if (self.tab.active === 'canceled') url = '/me/reservations/cancelled'

      self.$sdk.get(self, url, {
        token: self.user.token,
        brandId: self.brandId
      }, r => {
        if (!r.error) {
          let list = []
          r.list.forEach(rsvp => {
            let rsvpData = {
              id: rsvp.ID,
              service: rsvp.serviceType,
              pickup: rsvp.pickup,
              dropoff: rsvp.dropoff,
              pickupDate: moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('DD MMM YYYY'),
              dateSort: parseInt(moment(rsvp.pickupDate, 'YYYY-MM-DD HH:mm').format('x')),
              logo: rsvp.serviceType.image,
              isGround: true,
              isAsap: rsvp.isAsap
            }
            if (rsvp.lyft) {
              rsvpData.service.name = rsvp.lyft.custom_name
              rsvpData.logo = rsvp.lyft.custom_image
            }
            list.push(rsvpData)
          })
          self.$store.commit('flights/addFlightList', list)
          self.$store.commit('flights/sortList')
        } else {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: 'No trips as of yet.'
          })
          self.$store.commit('flights/setFlightTrackData', {enable: false})
          self.showSelected = false
          self.bcrumb = 1
          return
        }

        setTimeout(function () {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('flights/setFlightTrackData', {enable: false})
          self.showSelected = false
          self.bcrumb = 1
        }, 250)
      })
    },
    statusLabel (x) {
      if (x === 'COMPLETE') return 'COMPLETED'
      return x
    },
    dateOnly (x) {
      // return moment(x, 'MM/DD/YYYY hh:mmA').format('MMM DD, YYYY')
      return moment(x, 'MM/DD/YYYY hh:mmA').format('DD MMM YYYY')
    },
    timeOnly (x) {
      return moment(x, 'MM/DD/YYYY hh:mmA').format('hh:mmA')
    },
    rerouteToGround (id) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      ApiRsvpSearch.search(self, id, self.user.firstName, self.user.lastName, rsvp => {
        self.$store.commit('reservation/setMtechData', {enabled: rsvp.isMtech || false})

        self.$store.commit('global/setLoaderData', {show: false})
        if (rsvp.dispatchStatus === 'complete') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.rsvpCompleted')
          })
          return
        }

        if (rsvp.dispatchStatus === 'canceled') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.rsvpCancelled')
          })
          return
        }

        if (rsvp.dispatchStatus === 'ontheway') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.cannotEdit')
          })
          return
        }

        if (rsvp.dispatchStatus === 'onboard') {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: self.$t('searchEdit.onboard')
          })
          return
        }

        if (rsvp.provider.ID !== null && rsvp.provider.ID !== '' && rsvp.provider.ID !== CONFIG.lyft.driverId) {
          self.getRsvpASAP(rsvp)
          // self.$store.commit('rsvpEdit/setUnassignRsvp', {
          //   id: id,
          //   firstName: self.user.firstName,
          //   lastName: self.user.lastName
          // })
          // self.$store.commit('rsvpEdit/showUnassignDriver')
          return
        }

        self.$store.commit('reservation/setCharterData', {
          enabled: false,
          pickup: {},
          startDate: '',
          endDate: '',
          selectedService: ''
        })
        if (rsvp.discountCode && rsvp.isCorporate) {
          self.$root.$emit('redeemCode', {code: rsvp.discountCode})
        }
        self.$store.commit('flights/setFlightEditData', {
          id: id,
          target: '' // need to FIX
        })
        self.$store.commit('rsvpEdit/setOriginalRsvp', rsvp)
        self.$store.commit('rsvpEdit/setEditedRsvp', Object.assign({}, rsvp))
        self.$root.$router.push('rsvp-edit')
        window.location.href = '#/rsvp-edit'
      }, error => {
        console.log(error)
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: self.$t('searchEdit.rsvpDoesntExist')
        })
      })
    },
    lyftLabel (x) {
      if (x !== 'lyft' || this.lyftStore[x]) return x
      return this.lyftStore[x].name
    },
    getRsvpASAP (x) {
      let self = this

      self.$store.commit('global/setLoaderData', {show: true})
      ApiRsvpSearch.search(self, x.id, self.user.firstName, self.user.lastName, rsvp => {
        let errorMsg = ''
        if (rsvp.isMtech) errorMsg = 'Tracking is not available for this reservation.'
        if (rsvp.dispatchStatus === 'complete') errorMsg = self.$t('searchTrack.rsvpCompleted')
        if (rsvp.dispatchStatus === 'canceled') errorMsg = self.$t('searchTrack.rsvpCancelled')
        if (errorMsg) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: errorMsg
          })
          return
        }

        let charterData = {
          enabled: false,
          pickup: {},
          startDate: '',
          endDate: '',
          selectedService: ''
        }
        if (rsvp.isCharter) {
          let starDate = moment(rsvp.pickupTime, 'MM/DD/YYYY ' + ft.timeFormat(self, false))
          charterData = {
            enabled: true,
            pickup: rsvp.pickup,
            startDate: starDate.format('MM/DD/YYYY hh:mmA'),
            endDate: starDate.add(rsvp.eta, 'seconds').format('MM/DD/YYYY hh:mmA'),
            selectedService: rsvp.serviceCode
          }
        }
        self.$store.commit('reservation/setCharterData', charterData)

        if (rsvp.isAsap) {
          self.getAsapStatus(x.id, rsvp)
          return
        }

        if (rsvp.lyft && rsvp.lyft.webhookInfo) {
          rsvp.isLyft = true
          let lyftDriver = rsvp.lyft.webhookInfo.driver
          if (lyftDriver) {
            rsvp.provider.id = lyftDriver.id
            rsvp.provider.avatarUrl = lyftDriver.image_url
            rsvp.provider.firstName = lyftDriver.first_name
            rsvp.provider.lastName = ''
            rsvp.provider.rating = lyftDriver.rating
            rsvp.provider.email = lyftDriver.email || ''
            rsvp.provider.phones = [{
              countryCode: '',
              phoneNumber: lyftDriver.phone_number
            }]
          }
          let lyftVehicle = rsvp.lyft.webhookInfo.vehicle
          if (lyftVehicle) {
            rsvp.vehicle.photo = lyftVehicle.image_url
            rsvp.vehicle.manufacturer = lyftVehicle.make
            rsvp.vehicle.model = lyftVehicle.model
            rsvp.vehicle.plate = lyftVehicle.license_plate
          }
        }

        self.proceedToTrack(rsvp)
      }, error => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: self.$t('searchTrack.rsvpDoesntExist')
        })
        console.log(error)
      })
    },
    getAsapStatus (id, rsvp) {
      let self = this
      self.$sdk.get(self, `/reservations/${id}/${self.user.firstName}/${self.user.lastName}/asaptrack`, {}, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message.replace('backend.', '')
          })
          return
        }
        if (['droppedOff', 'canceled'].indexOf(r.status) > -1) {
          let msg = self.$t('searchTrack.rsvpCompleted')
          if (['canceled', 'cancelled'].indexOf(r.status) > -1) msg = self.$t('searchTrack.rsvpCancelled')
          self.$store.commit('global/setAlertData', {
            show: true,
            message: msg
          })
          return
        }
        let driver = r.lyft.driver
        if (r.lyft.webhookInfo && r.lyft.webhookInfo.driver) driver = r.lyft.webhookInfo.driver
        rsvp.provider.ID = driver.id
        rsvp.provider.avatarUrl = driver.image_url
        rsvp.provider.email = ''
        rsvp.provider.firstName = driver.first_name
        rsvp.provider.lastName = ''
        rsvp.provider.rating = driver.rating
        rsvp.provider.phones = [
          {
            countryCode: '',
            phoneNumber: driver.phone_number.replace('+', '')
          }
        ]
        let vehicle = r.lyft.vehicle
        if (r.lyft.webhookInfo && r.lyft.webhookInfo.vehicle) vehicle = r.lyft.webhookInfo.vehicle
        rsvp.vehicle.photo = vehicle.image_url
        rsvp.vehicle.manufacturer = vehicle.make
        rsvp.vehicle.model = vehicle.model
        rsvp.vehicle.plate = vehicle.license_plate
        self.proceedToTrack(rsvp)
      })
    },
    proceedToTrack (rsvp) {
      let self = this
      self.$store.commit('global/setLoaderData', {show: false})

      self.$store.commit('rsvpTrack/setRsvp', rsvp)
      self.$root.$router.push('rsvp-track')
      window.location = '#/rsvp-track'
    }
  },
  mounted () {
    this.bcrumb = 1
    // if (!this.flights.list.length && !this.track.enable) {
    //   this.$root.$router.push('search')
    // }

    if (this.track.enable) this.showSelected = true
  }
}
</script>

<style lang="scss" scoped>
.my-flights-box{
  max-width: 1300px;
  margin: 0 auto;
}
.back-btn{
  cursor: pointer;

  i{
    margin-right: 5px;
  }
}

.tabs-status{
  background: #fff;
  border-radius: 5px;
  padding: 5px 10px 0;
  margin: 20px 0 15px;
  gap: 10px;
  
  .-tab{
    padding: 20px 10px 10px;
    line-height: 1;
    letter-spacing: .7px;
    border-bottom: 4px solid #fff;
    color: #888;
    cursor: pointer;

    &.active{
      border-color: #ff9c09;
      color: #ff9c09;
      font-weight: 600;
    }
  }
  select{
    padding: 10px;
    font-weight: 18px;
    background: #fafafa;
    display: none;
  }
}

.f-breadcrumb{
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 5px;
  border-bottom: 1px solid #aaa;
  margin: 30px 0 0;
  line-height: 1;
  letter-spacing: .6px;
  color: #aaa;

  i{
    margin: 0 10px;
    font-size: 21px;
  }
  div{
    cursor: pointer;

    &:last-child{
      color: #2c3e50;
    }
  }
}

.flight-list-empty{
  background: #fff;
  border-radius: 10px;
  padding: 30px 20px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: .6px;
  color: #888;
}

.flight-box2{
  border: 2px solid #888;
  margin-bottom: 15px;
  background: #f8f8f8;
  border-radius: 4px;
  box-shadow: 2px 2px 2px rgba(0,0,0, .1);
  cursor: pointer;

  .fl-logo{
    width: 120px;
    padding: 10px;
    display: flex;
    align-items: center;
    background: #fdf9ed;

    img{
      max-width: 100px;
    }
  }
  .fl-info{
    width: 100%;
    padding: 0 10px 10px;
  }
  .fl-date{
    line-height: 1;
    padding: 10px;
    letter-spacing: .7px;
    font-size: 14px;
  }
  .fl-code{
    font-weight: 600;
    font-size: 21px;
    letter-spacing: .6px;
    width:calc((100% - 230px)/2);
    text-align: center;
  }
  .fl-pnr{
    text-align: center;
    width: 200px;

    .fa-plane{
      margin-bottom: 15px;
      color: #ECAE20;
    }
  }
  .pnr-info{
    letter-spacing: .6px;
    line-height: 1;
    label{
      color: #777;
      font-size: 14px;
    }
    span{
      display: block;
      font-weight: 600;
      font-size: 15px;
      margin-top: 3px;
    }
  }
  &.disabled{
    cursor: default;
  }
  &.ground-mode{
    .fl-logo{
      background: #f1f1f1;
    }
    .fl-code{
      font-size: 16px;
    }
  }
  .fl-spacer{
    text-align: right;
    align-content: center;
    width: 40px;
  }
  .fl-rt{
    background: #f0f0f0;
  }
}
.refund-label{
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 5px 10px;
  background: #41b430;
  color: #fff;
  border-radius: 4px;
  letter-spacing: .6px;

  &.non{
    background: #ccc;
    color: #333;
  }
}

.page-enter-active {
  transition: all 250ms ease;
 }
.page-leave-active {
  transition: all 140ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.page-enter, .page-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

@media only screen and (max-width: 640px) {
  .tabs-status{
    padding:10px!important;

    .-tab{
      display: none;
    }
    select{
      display: block;
    }
  }
  .flight-box2{
    .fl-logo{
      width: 100px;
      img{
        max-width: 80px;
      }
    }
    .fl-date{
      padding: 10px 0;
    }
    .refund-label{
      font-size: 12px;
      padding: 5px;
    }
    .fl-code{
      width: auto;
    }
    .fl-pnr{
      width: auto;
      min-width: 100px;
    }
    .fl-spacer{
      flex-grow: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5b4c7710